(() => {
  if (window.ggBundleCardPickerInstalled) return;
  window.ggBundleCardPickerInstalled = true;

  function select(choice) {
    const card = choice.closest('[data-bundle-card]');
    if (!card) return;
    card.querySelectorAll('[data-bundle-choice]').forEach(option => {
      option.setAttribute('aria-pressed', String(option === choice));
    });
    card.querySelectorAll('[data-bundle-link]').forEach(link => { link.href = choice.href; });
    card.querySelector('[data-bundle-price]').textContent = choice.dataset.price;
    const compare = card.querySelector('[data-bundle-compare]');
    compare.textContent = choice.dataset.compare || '';
    compare.hidden = !choice.dataset.compare;
    card.querySelector('[data-bundle-sold-out]').hidden = choice.dataset.available === 'true';
    const image = card.querySelector('.gb-product-image img');
    if (image && choice.dataset.image) {
      image.removeAttribute('srcset');
      image.src = choice.dataset.image;
      image.alt = choice.dataset.imageAlt;
    }
  }

  // Delegation also supports sections reloaded in Shopify's theme editor.
  document.addEventListener('click', event => {
    const choice = event.target.closest('[data-bundle-choice]');
    if (!choice || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    event.preventDefault();
    select(choice);
  });
  document.addEventListener('keydown', event => {
    const choice = event.target.closest('[data-bundle-choice]');
    if (choice && event.key === ' ') {
      event.preventDefault();
      select(choice);
    }
  });
})();
